import Vue from 'vue'
import Router from 'vue-router'
import Index from '@/views/index/Index.vue'
import About from '@/views/about/Index.vue'
import Category from '@/views/category/Index.vue'
import Login from '@/views/login/Index.vue'
import Register from '@/views/register/Index.vue'
import Jiameng from '@/views/jiameng/Index.vue'
import Ranking from '@/views/ranking/Index.vue'
import Safes from '@/views/safes/Index.vue'
import Search from '@/views/search/Index.vue'
import Shopsearch from '@/views/shop/shopsearch/shopsearch.vue'
import Catesearch from '@/views/shop/catesearch/catesearch.vue'
import Man from '@/views/man/Index.vue'
import Woman from '@/views/woman/Index.vue'
import Tehui from '@/views/tehui/Index.vue'
import Zhuxing from '@/views/zhuxing/Index.vue'
import Biyuntao from '@/views/biyuntao/Index.vue'
import Lingleiwanju from '@/views/lingleiwanju/Index.vue'
import Detail from '@/views/detail/Index.vue'
import MsDetail from '@/views/detail/ms_detail.vue'
import TjDetail from '@/views/detail/tj_detail.vue'
import Nxzw from '@/views/nxzw/Index.vue'
import Car from '@/views/car/Index.vue'
import Help from '@/views/help/Index.vue'
import Appdinggou from '@/views/help/appdinggou.vue'
import Ceomail from '@/views/help/ceomail.vue'
import Changjianwenti from '@/views/help/changjianwenti.vue'
import Dianhuadinggou from '@/views/help/dianhuadinggou.vue'
import Dingdan from '@/views/help/dingdan.vue'
import Dinggouliucheng from '@/views/help/dinggouliucheng.vue'
import Falvshengming from '@/views/help/falvshengming.vue'
import Fangshi from '@/views/help/fangshi.vue'
import Forgetpassword from '@/views/help/forgetpassword.vue'
import Fukuan from '@/views/help/fukuan.vue'
import Fuwuxieyi from '@/views/help/fuwuxieyi.vue'
import Huodaofukuan from '@/views/help/huodaofukuan.vue'
import Jifen from '@/views/help/jifen.vue'
import Jifenshiyong from '@/views/help/jifenshiyong.vue'
import Kefu from '@/views/help/kefu.vue'
import Qianshou from '@/views/help/qianshou.vue'
import Reg from '@/views/help/register.vue'
import Tuihuan from '@/views/help/tuihuan.vue'
import Weixindinggou from '@/views/help/weixindinggou.vue'
import Wuliu from '@/views/help/wuliu.vue'
import Yingyezhizhao from '@/views/help/yingyezhizhao.vue'
import Yinhang from '@/views/help/yinhang.vue'
import Yinsibaohu from '@/views/help/yinsibaohu.vue'
import Yinsizhengce from '@/views/help/yinsizhengce.vue'
import Youuhijuan from '@/views/help/youuhijuan.vue'
import Zaixian from '@/views/help/zaixian.vue'
import Zhengpinbaozheng from '@/views/help/zhengpinbaozheng.vue'
import User from '@/views/user/Index.vue'
import Article from '@/views/article/Index.vue'
import ArticleDetail from '@/views/article/article_detail.vue'
import Userinfor from '@/components/user/Index.vue'
import Order from '@/components/order/Index.vue'
import Coupon from '@/components/coupon/Index.vue'
import Fav from '@/components/fav/Index.vue'
import Grade from '@/components/grade/Index.vue'
import Profile from '@/components/profile/Index.vue'
import Address from '@/components/address/Index.vue'
import Faq from '@/components/faq/Index.vue'
import BuyLiji from '@/components/car/buy_liji.vue'
import BuyLijiMstj from '@/components/car/buy_liji_mstj.vue'
import payPassword from '@/views/car/pay_password.vue'
import BuyCarJiesuan from '@/components/car/buy_car_jiesuan.vue'
import EditPassword from '@/components/common/user-password.vue'
import AddAddress from '@/components/address/add.vue'
import EditAddress from '@/components/address/edit.vue'
import OrderDetail from '@/components/order/order_detail.vue'
import Weifahuo from '@/components/order/weifahuo.vue'
import Weifukuan from '@/components/order/weifukuan.vue'
import Weishouhuo from '@/components/order/weishouhuo.vue'
import Weipingjia from '@/components/order/weipingjia.vue'
import OrderReview from '@/components/order/order_review.vue'
import AfterSales from '@/components/order/shouhou.vue'
import ExpiredCoupon from '@/components/coupon/expired_coupon.vue'
import UseCoupon from '@/components/coupon/use_coupon.vue'
import Pintuan from '@/views/pintuan/Index.vue'
import Wx from '@/components/car/wx.vue'
import Zfb from '@/components/car/zfb.vue'
import RZfb from '@/components/recharge/zfb.vue'
import Rwx from '@/components/recharge/wx.vue'
import payGateWay from '@/components/car/payGateWay.vue'
import Money from '@/components/car/money.vue'
import ChiocePay from '@/components/car/chioce_pay.vue'
import PayOrder from '@/components/order/pay_order.vue'
import Success from '@/components/car/success.vue'
import Recharge from '@/views/recharge/index.vue'
import Orderrefund from '@/components/orderrefund/index.vue'
import Kf from '@/components/im/kf'
import Mes from '@/components/im/mes'
Vue.use(Router)

export default new Router({
  mode:'history',
  base:process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'Index',
      component: Index,
      meta:{index:1,title: '夜樱（yeain）情趣-玩具成人用品夫妻性用品官方商城'},
    },
    {
      path: '/about',
      name: 'About',
      component: About
    },
    {
      path: '/category',
      name: 'Category',
      component: Category
    },
    {
      path: '/login',
      name: 'Login',
      component: Login
    },
    {
      path: '/register',
      name: 'Register',
      component: Register
    },
    {
      path: '/jiameng',
      name: 'Jiameng',
      component: Jiameng
    },
    {
      path: '/ranking',
      name: 'Ranking',
      component: Ranking
    },
    {
      path: '/safes',
      name: 'Safes',
      component: Safes
    },
    {
      path: '/search',
      name: 'Search',
      component: Search
    },
    {
      path: '/shop/shopsearch',
      name: 'Shopsearch',
      component: Shopsearch
    },
    {
      path: '/shop/catesearch',
      name: 'Catesearch',
      component: Catesearch
    },
    {
      path: '/biyuntao',
      name: 'Biyuntao',
      component: Biyuntao
    },
    {
      path: '/lingleiwanju',
      name: 'Lingleiwanju',
      component: Lingleiwanju
    },
    {
      path: '/tehui',
      name: 'Tehui',
      component: Tehui
    },
    {
      path: '/man',
      name: 'Man',
      component: Man
    },
    {
      path: '/woman',
      name: 'Woman',
      component: Woman
    },
    {
      path: '/zhuxing',
      name: 'Zhuxing',
      component: Zhuxing
    },
    {
      path: '/detail',
      name: 'Detail',
      component: Detail
    },
    {
      path: '/ms_detail',
      name: 'MsDetail',
      component: MsDetail
    },
    {
      path: '/tj_detail',
      name: 'TjDetail',
      component: TjDetail
    },
    {
      path: '/nxzw',
      name: 'Nxzw',
      component: Nxzw
    },
    {
      path: '/car',
      name: 'Car',
      component: Car
    },
    {
      path: '/help',
      name: 'Help',
      component: Help
    },
    {
      path: '/help/appdinggou',
      name: 'Appdinggou',
      component: Appdinggou
    },
    {
      path: '/help/ceomail',
      name: 'Ceomail',
      component: Ceomail
    },
    {
      path: '/help/changjianwenti',
      name: 'Changjianwenti',
      component: Changjianwenti
    },
    {
      path: '/help/dianhuadinggou',
      name: 'Dianhuadinggou',
      component: Dianhuadinggou
    },
    {
      path: '/help/dingdan',
      name: 'Dingdan',
      component: Dingdan
    },
    {
      path: '/help/dinggouliucheng',
      name: 'Dinggouliucheng',
      component: Dinggouliucheng
    },
    {
      path: '/help/falvshengming',
      name: 'Falvshengming',
      component: Falvshengming
    },
    {
      path: '/help/fangshi',
      name: 'Fangshi',
      component: Fangshi
    },
    {
      path: '/help/forgetpassword',
      name: 'Forgetpassword',
      component: Forgetpassword
    },
    {
      path: '/help/fukuan',
      name: 'Fukuan',
      component: Fukuan
    },
    {
      path: '/help/fuwuxieyi',
      name: 'Fuwuxieyi',
      component: Fuwuxieyi
    },
    {
      path: '/help/huodaofukuan',
      name: 'Huodaofukuan',
      component: Huodaofukuan
    },
    {
      path: '/help/jifen',
      name: 'Jifen',
      component: Jifen
    },
    {
      path: '/help/jifenshiyong',
      name: 'Jifenshiyong',
      component: Jifenshiyong
    },
    {
      path: '/help/kefu',
      name: 'Kefu',
      component: Kefu
    },
    {
      path: '/help/qianshou',
      name: 'Qianshou',
      component: Qianshou
    },
    {
      path: '/help/reg',
      name: 'Reg',
      component: Reg
    },
    {
      path: '/help/tuihuan',
      name: 'Tuihuan',
      component: Tuihuan
    },
    {
      path: '/help/weixindinggou',
      name: 'Weixindinggou',
      component: Weixindinggou
    },
    {
      path: '/help/wuliu',
      name: 'Wuliu',
      component: Wuliu
    },
    {
      path: '/help/yingyezhizhao',
      name: 'Yingyezhizhao',
      component: Yingyezhizhao
    },
    {
      path: '/help/yinhang',
      name: 'Yinhang',
      component: Yinhang
    },
    {
      path: '/help/yinsibaohu',
      name: 'Yinsibaohu',
      component: Yinsibaohu
    },
    {
      path: '/help/yinsizhengce',
      name: 'Yinsizhengce',
      component: Yinsizhengce
    },
    {
      path: '/help/youuhijuan',
      name: 'Youuhijuan',
      component: Youuhijuan
    },
    {
      path: '/help/zaixian',
      name: 'Zaixian',
      component: Zaixian
    },
    {
      path: '/help/zhengpinbaozheng',
      name: 'Zhengpinbaozheng',
      component: Zhengpinbaozheng
    },
    {
      path: '/article',
      name: 'Article',
      component: Article
    },
    {
      path: '/article_detail',
      name: 'ArticleDetail',
      component: ArticleDetail
    },
    {
      path: '/user',
      name: 'User',
      component: User,
      children:[
        {
          path: '/user_order',
          name: 'Order',
          component: Order
        },
        {
          path: '/user_address',
          name: 'Address',
          component: Address
        },
        {
          path: '/user_fav',
          name: 'Fav',
          component: Fav
        },
        {
          path: '/user_coupon',
          name: 'Coupon',
          component: Coupon
        },
        {
          path: '/user_grade',
          name: 'Grade',
          component: Grade
        },
        {
          path: '/user_profile',
          name: 'Profile',
          component: Profile
        },
        {
          path: '/user_faq',
          name: 'Faq',
          component: Faq
        },
        {
          path: '/user_infor',
          name: 'Userinfor',
          component: Userinfor
        },
        {
          path: '/user_password',
          name: 'EditPassword',
          component: EditPassword
        },
        {
          path: '/add_address',
          name: 'AddAddress',
          component: AddAddress
        },
        {
          path: '/edit_address',
          name: 'EditAddress',
          component: EditAddress
        },
        {
          path: '/order_detail',
          name: 'OrderDetail',
          component: OrderDetail
        },
        {
          path: '/weifahuo',
          name: 'Weifahuo',
          component: Weifahuo
        },
        {
          path: '/weifukuan',
          name: 'Weifukuan',
          component: Weifukuan
        },
        {
          path: '/weishouhuo',
          name: 'Weishouhuo',
          component: Weishouhuo
        },
        {
          path: '/weipingjia',
          name: 'Weipingjia',
          component: Weipingjia
        },
        {
          path: '/expired_coupon',
          name: 'ExpiredCoupon',
          component: ExpiredCoupon
        },
        {
          path: '/use_coupon',
          name: 'UseCoupon',
          component: UseCoupon
        },
        {
          path: '/shouhou',
          name: 'AfterSales',
          component: AfterSales
        },
        {
          path: '/order_review',
          name: 'OrderReview',
          component: OrderReview
        },
        {
          path: '/orderrefund',
          name: 'Orderrefund',
          component: Orderrefund
        },
      ]
    },
    {
      path: '/buy_liji',
      name: 'BuyLiji',
      component: BuyLiji
    },
    {
      path: '/buy_liji_mstj',
      name: 'BuyLijiMstj',
      component: BuyLijiMstj
    },
    {
      path: '/buy_car_jiesuan',
      name: 'BuyCarJiesuan',
      component: BuyCarJiesuan
    },
    {
      path: '/miaosha',
      name: 'Pintuan',
      component: Pintuan
    },
    {
      path: '/wx',
      name: 'Wx',
      component: Wx
    },
    {
      path: '/zfb',
      name: 'Zfb',
      component: Zfb
    },
    {
      path: '/payGateWay',
      name: 'payGateWay',
      component: payGateWay
    },
    {
      path: '/rzfb',
      name: 'RZfb',
      component: RZfb
    },
    {
      path: '/rwx',
      name: 'Rwx',
      component: Rwx
    },
    {
      path: '/money',
      name: 'Money',
      component: Money
    },
    {
      path: '/payorder',
      name: 'ChiocePay',
      component: ChiocePay
    },
    {
      path: '/pay_unpaid_order',
      name: 'PayOrder',
      component: PayOrder
    },
    {
      path: '/success',
      name: 'Success',
      component: Success
    },
    {
      path: '/recharge',
      name: 'Recharge',
      component: Recharge
    },
    { 
      path: '/im/kf',
      name: 'Kf', 
      component: Kf 
    },
    { 
      path: '/im/mes', 
      name: 'Mes', 
      component: Mes 
    },
    { 
      path: '/pay_password', 
      name: 'payPassword', 
      component: payPassword 
    },
  ]
})

//重复点击导航路由报错

const routerPush = Router.prototype.push
  Router.prototype.push = function push(location) {
  return routerPush.call(this, location).catch(error=> error)
}





// WEBPACK FOOTER //
// ./src/router/index.js